import { useCallback, useEffect, useState } from "react";
import { Send, Loader2, CheckCircle2, AlertCircle } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, formatApiError } from "@/lib/api";

export function WhatsAppAutoSettings({ settings, setSettings }) {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => api.get("/whatsapp/status").then(({ data }) => setStatus(data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const sendNow = async () => {
    if (!window.confirm("Inviare adesso il riepilogo di oggi su WhatsApp a tutto il personale con numero?")) return;
    setBusy(true);
    try {
      const { data } = await api.post("/whatsapp/send-now");
      const ok = data.results.filter((r) => r.ok && r.sid).length;
      toast.success(`Riepilogo inviato (${ok} messaggi)`);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
      load();
    }
  };

  return (
    <div className="rounded-xl bg-[var(--surface-2)] p-4 space-y-3" data-testid="whatsapp-auto-settings">
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="font-semibold text-sm">Invio automatico su WhatsApp</p>
          <p className="text-xs text-[var(--muted)]">Ogni giorno all'ora scelta (entro 15 minuti) ogni operatore riceve i suoi appuntamenti; l'amministratore li riceve tutti.</p>
        </div>
        <Switch checked={!!settings.whatsapp_auto} onCheckedChange={(v) => setSettings({ ...settings, whatsapp_auto: v })} data-testid="settings-whatsapp-auto-switch" />
      </div>
      {status && (
        <p className={`flex items-center gap-1.5 text-xs font-semibold ${status.configured ? "text-emerald-700" : "text-amber-700"}`} data-testid="whatsapp-config-status">
          {status.configured ? <CheckCircle2 className="h-4 w-4" /> : <AlertCircle className="h-4 w-4" />}
          {status.configured ? "Account Twilio collegato" : "Account Twilio non ancora collegato"}
        </p>
      )}
      <button type="button" onClick={sendNow} disabled={busy || !status?.configured} className="btn-secondary h-10 px-4" data-testid="whatsapp-send-now-button">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Invia adesso il riepilogo di oggi
      </button>
      {status?.runs?.length > 0 && (
        <ul className="text-xs space-y-1" data-testid="whatsapp-runs">
          {status.runs.slice(0, 5).map((r) => (
            <li key={r.started_at}>
              <span className="font-mono">{new Date(r.started_at).toLocaleString("it-IT")}</span> · {r.kind === "auto" ? "automatico" : "manuale"} ·{" "}
              {(r.results || []).map((x) => `${x.to}: ${x.ok ? (x.sid ? "inviato" : x.info || "ok") : `errore (${x.error})`}`).join(", ") || r.status}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
